export default __webpack_public_path__ + "static/media/AT-2020-16-2.a37bf96c.png";